import React from "react"

import { Box } from "@mui/material"

const ReferralTableCellMid = ({ referral }) => {
  return (
    <Box sx={{
      backgroundColor: !referral.subscription ? "#DBDEE2" : "#E5F5FA",
      color: !referral.subscription ? "#7F91A8" : "#009ECF",
      fontWeight: !referral.subscription ? "600" : "500",
      fontSize: "9px",
      padding: "2px 8px",
      borderRadius: "38px"
    }}>
      {
        !referral.subscription ?
          "No" :
          `Next: ${referral.subscription}`
      }
    </Box>
  )
}

export default ReferralTableCellMid